import { createContext, useContext } from 'react'
import type { ChartInteractionSettings } from '@edge/charts'

export interface ChartInteractionContextValue {
  /** Current global interaction settings, shared by every chart on screen. */
  interaction: ChartInteractionSettings
  /** Merge a partial patch into the current settings and persist. */
  update: (patch: Partial<ChartInteractionSettings>) => void
  /** Replace settings wholesale with a built-in preset's object and persist.
   *  No-op for an unknown id. */
  applyPreset: (id: string) => void
}

export const ChartInteractionContext = createContext<ChartInteractionContextValue | null>(null)

export function useChartInteraction(): ChartInteractionContextValue {
  const ctx = useContext(ChartInteractionContext)
  if (!ctx) throw new Error('useChartInteraction must be used within ChartInteractionProvider')
  return ctx
}
